import { useContext } from "react";
import { ProfileContext } from "../context/ProfileContext";

export function useProfileData() {
  return useContext(ProfileContext);
}
